import {Injectable} from '@angular/core';
import {createNumberMask} from 'text-mask-addons/dist/textMaskAddons';
import * as moment from 'moment';

@Injectable({
   providedIn: 'root'
})
export class UtilService {
   
   constructor() {
   }

//#region Utils
   today(format?: string) {
      return moment().format(format ? format : 'YYYY-MM-DD');
   }
   
   convertFloat(value: any) {
      if (!value) {
         return 0;
      }
      try {
         let parse = value;
         parse = parse.includes('$') ? value.replace('$', '').trim() : parse;
         parse = parse.includes('%') ? parse.replace('$', '').trim() : parse;
         return parseFloat(parse.replace(/[^\d\.\-]/g, ''));
      } catch (e) {
         return value;
      }
   }
   
   parseCodigoLocalizacion(codigo: number) {
      let pCodigo = codigo.toString();
      return pCodigo.length == 2 ? pCodigo : '0' + pCodigo;
   }

//#endregion Utils

//#region Mask
   
   getCreateEnteroMask(params?: any) {
      return createNumberMask({
         prefix: '',
         allowDecimal: false,
         includeThousandsSeparator: false,
         allowLeadingZeroes: true,
         ...params
      });
   }
   
   getCreateDecimalDolarMask() {
      return createNumberMask({
         prefix: '$ ',
         allowDecimal: true,
         decimalLimit: 2,
      });
   }
   
   getCreateDecimalMask() {
      return createNumberMask({
         prefix: '',
         allowDecimal: true,
         decimalLimit: 2,
      });
   }
   
   getCreatePorcentajeMask() {
      return createNumberMask({
         prefix: '',
         suffix: ' %',
         integerLimit: 3,
         allowDecimal: true,
         decimalLimit: 2,
      });
   }

//#endregion Mask

//#region Format
   
   public getValueFormatInteger(data: any) {
      let value: number = 0;
      let result: string = '';
      
      value = data.value;
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'decimal',
               useGrouping: true,
               minimumFractionDigits: 0,
               maximumFractionDigits: 0
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public getValueFormatNumber(data: any) {
      let value: number = 0;
      let result: string = '';
      
      value = data.value;
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'decimal',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public getValueFormatCurrency(data: any) {
      let value: number = 0;
      let result: string = '';
      
      value = data.value;
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'currency',
               currency: 'USD',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public getValueFormatPercent(data: any) {
      let value: number = 0;
      let result: string = '';
      
      value = data.value;
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'percent',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
//#endregion Format
}
